import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^auth\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('auth/' + key);
  }
}
